module.exports = __webpack_public_path__ + "img/Kd.258afc4c.png";